import { Stack, styled } from "@mui/material"
import { colors } from "themes/palette/colors"

interface ITriggerProps {
  isOpen: boolean
}

export const TriggerStack = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "isOpen",
})<ITriggerProps>(({ isOpen }) => ({
  cursor: "pointer",
  borderRadius: "10px",
  margin: "12px 4px 0",
  padding: "7px 10px",
  transition: "background-color 0.2s ease, box-shadow 0.2s ease",
  backgroundColor: isOpen ? colors.whiteAlpha13 : "transparent",
  boxShadow: isOpen ? `inset 0 0 0 1px ${colors.whiteAlpha13}` : "none",
  "&:hover": {
    backgroundColor: isOpen ? colors.whiteAlpha20 : colors.whiteAlpha8,
  },
  "&:active": {
    backgroundColor: colors.whiteAlpha20,
    transform: "scale(0.99)",
  },
}))
